// extracted by mini-css-extract-plugin
module.exports = {"black":"A-gGTU","brand":"weoQGo","gray":"_2o4YUd","gray-50":"_1tS70H","gray-70":"_1Qf3cx","green":"_1Z_Rdz","white":"_2N8Zqq","error":"_1SCJ3D"};